// extracted by mini-css-extract-plugin
module.exports = {"amenities-list":"c6e8ba5398--amenities-list--2Xl5i","amenity-item":"c6e8ba5398--amenity-item--3gwlZ"};